// extracted by mini-css-extract-plugin
export default {"form":"form-x01Yp","passwordLabel":"passwordLabel-zOqli","forgotPassword":"forgotPassword-wor8k"};